import React from "react";
import { Box, Grid } from "@mui/material";
import SectionTitle from "../components/SectionTitles/SectionTitle";
import { images } from "./galleryImages";

const GalleryPage = () => {
  return (
    <div>
      <Box sx={{ padding: 4 }}>
        {/* <SectionTitle
          titleOption="text-center mb-0"
          title="Local Rounds: Through the Lens"
          subTitle=""
        /> */}
        <h2 className="text-center mb-0">Local Rounds: Through the Lens</h2>
        <br />

        <Grid container spacing={2}>
          {images.map((img, index) => (
            <Grid item xs={6} sm={4} md={3} key={index}>
              <Box
                component="img"
                src={img}
                alt={`Gallery ${index + 1}`}
                sx={{
                  width: "100%",
                  height: 200, // same fixed height for uniform size
                  objectFit: "cover",
                  objectPosition: "center",
                  borderRadius: 2,
                  cursor: "pointer",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: 4,
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default GalleryPage;
